export const plans = [
    {
        id: 1,
        name: "Basic",
        features: [
            "Publish 100 products to Faire",
            "100 order syncs",
            "Export from Wix to Faire",
            "Import from Faire to Wix",
            "Inventory sync (two ways)",
            "Currency converter",
            "24/7 livechat on weekdays - email support on weekends",
        ],
        price: 29,
        currency: "$",
        productId: "basic1",
    },
    {
        id: 2,
        name: "Intermediate",
        features: [
            "Publish 300 products to Faire",
            "300 order syncs",
            "Export from Wix to Faire",
            "Import from Faire to Wix",
            "Inventory sync (two ways)",
            "Currency converter",
            "24/7 livechat on weekdays - email support on weekends",
        ],
        price: 39,
        currency: "$",
        productId: "intermediate",
    },
    {
        id: 3,
        name: "Advanced",
        features: [
            "Publish 1000 products to Faire",
            "1000 order syncs",
            "Export from Wix to Faire",
            "Import from Faire to Wix",
            "Inventory sync (two ways)",
            "Currency converter",
            "24/7 livechat on weekdays - email support on weekends",
        ],
        price: 59,
        currency: "$",
        productId: "advanced",
    },
    {
        id: 4,
        name: "Super",
        features: [
            "Publish 3000 products to Faire",
            "3000 order syncs",
            "Export from Wix to Faire",
            "Import from Faire to Wix",
            "Inventory sync (two ways)",
            "Currency converter",
            "24/7 livechat on weekdays - email support on weekends",
        ],
        price: 79,
        currency: "$",
        productId: "super",
    },
];